import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { cloneDeep, forEach } from 'lodash';

@Component({
  selector: 'app-order-widgets',
  templateUrl: './order-widgets.component.html',
  styleUrls: ['./order-widgets.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class OrderWidgetsComponent implements OnInit{
  
  widgets = [];
  allSelected = false;
  
  constructor(
    public matDialogRef: MatDialogRef<OrderWidgetsComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) {
    this.widgets = cloneDeep(this._data);
  }
  
  ngOnInit(): void {
    this.updateMasterToggle();
  }

  onDrop(dropResult: CdkDragDrop<any[]>): void {
    moveItemInArray(this.widgets, dropResult.previousIndex, dropResult.currentIndex);
    forEach(this.widgets, (widget, key) => {
      widget.order = key;
    });
  }
  
  toggleVisibility(widget : any): void {
    widget.visible = !widget.visible;
    this.updateMasterToggle();
  }
  
  toggleAll(event: any) {
    const isChecked = event.checked;
    this.widgets.forEach(widget => widget.visible = isChecked);
    this.allSelected = isChecked;
  }
  
  updateMasterToggle() {
    this.allSelected = this.widgets.every(widget => widget.visible);
  }

}
